<section id="sshipping-section" class="feat-pro2 bg-white pt-5 pb-2" >
  <div class="container flex-column justify-content-between px-0 d-flex">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <p class="h2 p-2 font-weight-bold text-center section-title">{{title}}</p>
      </div>
    </div>
    <div class="row flex-column align-items-center flex-md-row justify-content-center">
      <div class="flex-column align-items-center position-relative px-2 py-4 m-auto"
           style="border-radius: 15px; max-height: 550px">
        <img class="d-block d-md-none" width="300" height="298" src="assets/market-amazon/amazon-ship.png">
        <img class="d-none d-md-block d-lg-none" width="350" height="348" src="assets/market-amazon/amazon-ship.png">
        <img class="d-none d-lg-block d-xl-none" width="450" height="448" src="assets/market-amazon/amazon-ship.png">
        <img class="d-none d-xl-block" width="555" height="553" src="assets/market-amazon/amazon-ship.png">
        <div
          class="position-absolute pb-2 pl-2 pl-md-4 d-flex flex-column align-items-start justify-content-center cta w-100">
          <span class="h2 text-center text-white mt-3 my-md-3 font-weight-normal shipping-text"
                style="text-transform: none">Envíos Marítimos</span>
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <p class="mb-0 text-white">Entrega a $2.99 por libra</p>
              <p class="mb-0 text-white">de 15 a 35 días hábiles</p>
              <small class="mb-0 text-white">15 libras mín. recomendado</small>
            </div>
            <div class="d-flex flex-column align-items-end mr-5 mt-auto">
              <button (click)="getAmazonProducts(1)"
                      class="btn bg-transparent px-2 py-2 font-weight-bold OpenSans rounded-pill w-100 position-relative text-white"
                      style="color: #47BFAB;">
                <span class="d-block d-lg-none">Comprar</span>
                <span class="d-none d-lg-block">Comprar Ahora</span>
              </button>
            </div>

          </div>
        </div>
      </div>
      <div class="flex-column align-items-center position-relative px-2 py-4 m-auto"
           style="border-radius: 15px;max-height: 550px">
        <img class="d-block d-md-none" width="300" height="298" src="assets/market-amazon/amazon-flight.png">
        <img class="d-none d-md-block d-lg-none" width="350" height="348" src="assets/market-amazon/amazon-flight.png">
        <img class="d-none d-lg-block d-xl-none" width="450" height="448" src="assets/market-amazon/amazon-flight.png">
        <img class="d-none d-xl-block" width="555" height="553" src="assets/market-amazon/amazon-flight.png">
        <div
          class="position-absolute pb-2 pl-2 pl-md-4 d-flex flex-column align-items-start justify-content-center cta w-100">
          <span class="h2 text-center text-white mt-3 my-md-3 font-weight-normal shipping-text"
                style="text-transform: none">Envíos Aéreos</span>
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <p class="mb-0 text-white">Entrega a $3.99 por libra</p>
              <p class="mb-0 text-white">de 7 a 15 días hábiles</p>
              <small class="mb-0 text-white">15 libras mín. recomendado</small>
            </div>
            <div class="d-flex flex-column align-items-end mr-5 mt-auto">
              <button (click)="getAmazonProducts(2)"
                      class="btn bg-transparent px-2 py-2 font-weight-bold OpenSans rounded-pill w-100 position-relative text-white"
                      style="color: #47BFAB;">
                <span class="d-block d-lg-none">Comprar</span>
                <span class="d-none d-lg-block">Comprar Ahora</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>
